import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IVincularClienteForm } from "../../../../types/agendamento";

export const useVincularAgendamentoCliente = () => {
  return useMutation({
    mutationFn: (data: IVincularClienteForm) =>
      Agendamento.vincularAgendamentoAoCliente(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
